import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const removeCustomPanelMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Remove Panel',
		onClick: ({ context, controller }): void => {
			controller.publishRequestedAction('remove_custom_panel', context.id);
		}
	};
};
